import styled from 'styled-components';

export const Title = styled.h1`
  color: white;
  font-size: 52px;
  margin: 0 0 10px 0;
  width: 100%;
`;

export const Subtitle = styled.h2`
  color: white;
  font-size: 32px;
  margin: 0 0 60px 0;
  margin: 0 auto 30px;
`;



// WEBPACK FOOTER //
// ./src/containers/Home/styles.js